import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import * as S from '../styled';

export const Section = styled(S.Section)`
    padding-bottom: 0;
    background: linear-gradient(to top,#1c293a,#010914);    
`;

export const HeadTitle = styled.h1`
    margin: 0;
    margin-bottom: 60px;
    width: 100%;
    font-size: 60px;
    line-height: 1.2;
    color: ${COLORS.white};
    text-align: center;
`;

export const HeadText = styled.div`
    margin-bottom: 40px;
    width: 100%;
    font-size: 20px;
    line-height: 1.8;
    color: ${COLORS.white};
    text-align: center;
`;

export const BottomWrap = styled.div`
    width: 100%;
    background-color: #000;
`;

export const List = styled(S.List)`
    padding: 40px 0;
    @media(max-width: ${S.breakePoints.tablet}) {
        flex-direction: column;
    }
`;

export const ListItem = styled(S.ListItem)`
    @media(max-width: ${S.breakePoints.tablet}) {
        margin-right: 0;
        margin-bottom: 30px;
    }
`;
